module.exports = __webpack_public_path__ + "img/fidc-bg-2.284085dc.png";